import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CheckCircle2, Loader2, AlertTriangle } from "lucide-react";
import { api } from "@/lib/api";

const MAX_TRIES = 6;

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const bookingToken = params.get("b");
  const [state, setState] = useState(sessionId ? "checking" : "missing");

  useEffect(() => {
    if (!sessionId) return;
    let tries = 0;
    let timer;
    const next = () => { if (++tries < MAX_TRIES) timer = setTimeout(poll, 2000); else setState("pending"); };
    const poll = () => api.get(`/payments/status/${sessionId}`).then((r) => {
      if (r.data.payment_status === "paid") return setState("paid");
      if (["expired", "failed"].includes(r.data.payment_status)) return setState("failed");
      next();
    }).catch(next);
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  const back = bookingToken ? `/book/manage/${bookingToken}` : "/";
  return (
    <div className="max-w-2xl mx-auto px-4 sm:px-6 py-20" data-testid="payment-success">
      <div className="dg-card rounded-2xl p-8 text-center">
        {state === "checking" && <><Loader2 className="w-12 h-12 text-cyan-400 mx-auto animate-spin" /><div className="dg-eyebrow mt-4">Checking payment…</div><h1 className="mt-2 text-3xl font-extrabold font-display" data-testid="payment-title">One moment.</h1></>}
        {state === "paid" && <><CheckCircle2 className="w-12 h-12 text-emerald-400 mx-auto" /><div className="dg-eyebrow mt-4">Paid</div><h1 className="mt-2 text-3xl sm:text-4xl font-extrabold font-display" data-testid="payment-title">Thank you — payment received.</h1><p className="text-slate-300 mt-3">A receipt is on its way to your inbox. David has been notified too.</p></>}
        {state === "pending" && <><Loader2 className="w-12 h-12 text-cyan-400 mx-auto" /><div className="dg-eyebrow mt-4">Still confirming</div><h1 className="mt-2 text-3xl font-extrabold font-display" data-testid="payment-title">Almost there.</h1><p className="text-slate-300 mt-3">We couldn't confirm the payment just yet. It will show as paid on your booking page within a few minutes — check there before paying again, or call 310-422-0669.</p></>}
        {state === "failed" && <><AlertTriangle className="w-12 h-12 text-amber-400 mx-auto" /><div className="dg-eyebrow mt-4">Not completed</div><h1 className="mt-2 text-3xl font-extrabold font-display" data-testid="payment-title">That payment didn't go through.</h1><p className="text-slate-300 mt-3">No charge was made. You can try again from your booking page, or call 310-422-0669.</p></>}
        {state === "missing" && <><AlertTriangle className="w-12 h-12 text-amber-400 mx-auto" /><h1 className="mt-4 text-3xl font-extrabold font-display" data-testid="payment-title">Nothing to check here.</h1></>}
        <Link to={back} className="dg-btn-primary rounded-full px-6 py-3 text-sm inline-flex mt-8" data-testid="payment-back-btn">{bookingToken ? "Back to your booking" : "Back to Dr.Gadget"}</Link>
      </div>
    </div>
  );
}
